import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Props {
  cities: string[]
  year: number
}

export default function download({ cities, year }: Props) {
  const variables = { cities, year }
  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            contracts: { exportList },
          },
        },
      },
    }: any) => exportList
  )
}

const query = gql`
  query costByCity($cities: [String], $year: Int) {
    viewer {
      company {
        contracts(cities: $cities, year: $year, type: OperationCost) {
          exportList
        }
      }
    }
  }
`
